import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { PromotionBarComponent } from './shared/components/promotion-bar/promotion-bar.component';
import { SeoService } from './core/services/seo.service';
import { SiteConfigService } from './core/config/site-config.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent, PromotionBarComponent],
  template: `
    <a href="#main-content" class="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-brand-600 focus:text-white focus:rounded-lg focus:text-sm focus:font-semibold">
      Skip to main content
    </a>
    @if (topPromo) {
      <app-promotion-bar [promo]="topPromo" />
    }
    <app-header />
    <main id="main-content" role="main">
      <router-outlet />
    </main>
    <app-footer />
  `,
})
export class App implements OnInit {
  private seo = inject(SeoService);
  private config = inject(SiteConfigService);

  topPromo = this.config.promotions.topBar;

  ngOnInit(): void {
    this.seo.init();
  }
}
